import { useManageQueryParameters } from '@luna/router';

import type { BooleanAsString, DirectionFilter, SearchState } from './types';
import { getCommaSeparatedParam } from './getCommaSeparatedParam';

export const useSearchStateFromUrl = (): SearchState => {
    const { getParam } = useManageQueryParameters();

    const cardIds = getCommaSeparatedParam(getParam('cardIds'));
    const maskedCardNumber = getCommaSeparatedParam(getParam('maskedCardNumber'));
    const accounts = getCommaSeparatedParam(getParam('accounts'));

    return {
        cardIds,
        maskedCardNumber,
        accounts,
        includeContainedTransactions: getParam('includeContainedTransactions') as BooleanAsString,
        replaceBulkTransactions: getParam('replaceBulkTransactions') as BooleanAsString,
        direction: getParam('direction') as DirectionFilter,
        keyword: getParam('keyword'),
        amount: {
            minAmount: getParam('minAmount'),
            maxAmount: getParam('maxAmount'),
        },
        dates: {
            startDate: getParam('startDate'),
            endDate: getParam('endDate'),
        },
        billIdRange: {
            billIdFrom: getParam('billIdFrom'),
            billIdTo: getParam('billIdTo'),
        },
        variableSymbol: getParam('variableSymbol'),
    };
};
